/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint jsx-a11y/no-static-element-interactions: 0 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import moment from 'moment-timezone';
import qs from 'qs';
import { Link, withRouter } from 'react-router';
import { withTranslation } from 'react-i18next';
import { markdownToDraft } from 'markdown-draft-js';
import { EditorState, convertFromRaw } from 'draft-js';
import Auth from '@aws-amplify/auth';
import {
  Dimmer,
  Dropdown,
  Grid,
  Table,
  Loader,
  Icon,
  Label,
  Header,
  Menu,
  Popup,
  Image,
  Button,
} from 'semantic-ui-react';

import config from '../../config';
import isNumber from '../utils/numbers/isNumber';
import { decodeSearch, encodeSearch } from '../utils/url';
import isbase64 from '../utils/isbase64';
import { BookingDatePicker, BookingSelectList, BookingSelectListMultiple } from './Filters';
import { flashErrorMessage, flashSuccessMessage } from '../actions/flash';
import { fetchM, fetchAPI, serverRequestGet } from '../actions/fetchM';
import PageNav from './PageNav';
import PopupButtonList from './PopupButtonList';
import SearchIn from './SearchIn';
import SortButton from './SortButton';
import Timestamp from './Timestamp';
import FixedBarStatus from './FixedBarStatus';
import * as endpoints from '../constants/apiEndpoints';
import { AGING_DATE_RANGE } from '../constants/dateRanges';
import {
  bookingStatusesAll,
  bookingStatusesTabs,
  isBookingPendingCancellation,
} from '../constants/bookingStatuses';
import { isCountryVietnam } from '../constants/countries';
import { bookingIDCellValue, createdByLabel, showBookingIDColumn as vnShowBookingIDColumn, showsPaymentExcelExport, unitQuotaChipLabel } from '../utils/vietnam';
import { getLawyerCaseStatuses, LAWYER_CASE_TYPES, LAWYER_ALL_STATUSES, DEVELOPER_CANCELLED } from '../constants/lawyerCaseStatuses';
import PAYMENT_STATUSES from '../constants/paymentStatuses';
import { namespaces, TRANSLATION_FILES } from '../constants/translation';
import { fetchWithCacheSWR } from '../utils/fetchWithCacheSWR';

const tabs = [
  { value: 'all', name: 'all', text: 'All', header: 'Latest Bookings' },
  { value: 'aging_by_units', name: 'aging_by_units', text: 'Aging By Units', header: 'Aging By Units' },
  { value: 'aging_by_bankers', name: 'aging_by_bankers', text: 'Aging By Bankers', header: 'Aging By Bankers' },
  { value: 'aging_by_lawyers', name: 'aging_by_lawyers', text: 'Aging By Lawyers', header: 'Aging By Lawyers' },
];

const allFilterNames = [
  'bookingStatusMulti',
  'dateRange',
  'dateFrom',
  'dateTo',
  'cancelledDateRange',
  'cancelledDateFrom',
  'cancelledDateTo',
  'expiredDateRange',
  'expiredDateFrom',
  'expiredDateTo',
  'bookedDateRange',
  'bookedDateFrom',
  'bookedDateTo',
  'soldDateRange',
  'soldDateFrom',
  'soldDateTo',
  'paymentStatus',
  'filteredProjects',
  'agingRange',
  'loanStatus',
  'agingDuration',
  'lawyerCaseType',
  'lawyerCaseStatus',
];

class BookingsList extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        companyID: PropTypes.number,
        lawyerIsEnabled: PropTypes.bool,
      }),
    }),
    where: PropTypes.shape({}),
    projectUnitID: PropTypes.string,
    onLoading: PropTypes.func,
    noScrollTop: PropTypes.bool,
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isBranchLeaderSupervisor: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      groups: PropTypes.arrayOf(PropTypes.shape({
        code: PropTypes.string,
      })),
      companyBranch: PropTypes.shape({
        isExternal: PropTypes.bool,
      }),
      company: PropTypes.shape({
        countryCode: PropTypes.string,
      }),
      isExternalAgentLeader: PropTypes.bool,
    }),
    hideBookingList: PropTypes.bool,
    bookingListLength: PropTypes.func,
    isUnitOverview: PropTypes.bool,
    t: PropTypes.func,
  }
  static defaultProps = {
    hideBookingList: false,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
  })
  static getPropsToState = (props) => {
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < 768;
    const query = decodeSearch(props.location.search);
    const currentPage = parseInt(query.page, 10) || 1;
    const search = query.search || '';
    const searchIn = query.searchIn || '';
    const dateRange = query.dateRange || '';
    const cancelledDateRange = query.cancelledDateRange || '';
    const expiredDateRange = query.expiredDateRange || '';
    const bookedDateRange = query.bookedDateRange || '';
    const soldDateRange = query.soldDateRange || '';
    const loanStatus = query.loanStatus || [];
    const duration = query.duration || '';
    const bookingStatus = query.bookingStatus || '';
    const bookingStatusMulti = query.bookingStatusMulti || [];
    const agingRange = query.agingRange || '';
    const agingDuration = query.agingDuration || '';
    const paymentStatus = query.paymentStatus || [];
    const lawyerCaseType = query.lawyerCaseType || '';
    const lawyerCaseStatus = query.lawyerCaseStatus || '';
    const projectFilter = (isbase64(query.projectFilter) && qs.parse(atob(query.projectFilter)).name) || '';
    const staffFilter = (isbase64(query.staffFilter) && qs.parse(atob(query.staffFilter)).name) || '';
    const dateFrom = query.dateFrom ? query.dateFrom : '';
    const dateTo = query.dateTo ? query.dateTo : '';
    const cancelledDateFrom = query.cancelledDateFrom ? query.cancelledDateFrom : '';
    const cancelledDateTo = query.cancelledDateTo ? query.cancelledDateTo : '';
    const expiredDateFrom = query.expiredDateFrom ? query.expiredDateFrom : '';
    const expiredDateTo = query.expiredDateTo ? query.expiredDateTo : '';
    const bookedDateFrom = query.bookedDateFrom ? query.bookedDateFrom : '';
    const bookedDateTo = query.bookedDateTo ? query.bookedDateTo : '';
    const soldDateFrom = query.soldDateFrom ? query.soldDateFrom : '';
    const soldDateTo = query.soldDateTo ? query.soldDateTo : '';
    const loadingProjectSearch = false;
    const loadingStaffSearch = false;
    const findProjectResults = [];
    const findStaffResults = [];
    const loadingMessage = `${props.t('Loading', { ns: TRANSLATION_FILES.translation })}...`;
    const noResultsMessage = loadingMessage;
    const noStaffResultsMessage = loadingMessage;
    const hasLawyerAccess = props.auth && props.auth.companyBranch && !props.auth.isExternalAgent;
    const lawyerIsEnabled = props.appConfig && props.appConfig.data && props.appConfig.data.lawyerIsEnabled && hasLawyerAccess;
    // CPI-1209 (A37): Vietnam has no lawyer module, so the Aging By Lawyers tab is dropped there.
    const showLawyerTab = lawyerIsEnabled &&
      !isCountryVietnam(props.auth && props.auth.company && props.auth.company.countryCode);
    // const hasAccess = props.auth.isHeadquarters || props.auth.isSuperAdmin;
    const tabss = showLawyerTab ? tabs : tabs.filter(t => t.value !== 'aging_by_lawyers');
    const currentTab = tabss.some(t => t.value === query.tab) ? query.tab : tabs[0].value;
    return {
      isMobile,
      search,
      searchIn,
      dateRange,
      cancelledDateRange,
      expiredDateRange,
      bookedDateRange,
      soldDateRange,
      loanStatus,
      duration,
      bookingStatus,
      bookingStatusMulti,
      agingRange,
      agingDuration,
      paymentStatus,
      projectFilter,
      staffFilter,
      dateTo,
      dateFrom,
      cancelledDateFrom,
      cancelledDateTo,
      expiredDateFrom,
      expiredDateTo,
      bookedDateFrom,
      bookedDateTo,
      soldDateFrom,
      soldDateTo,
      loadingProjectSearch,
      loadingStaffSearch,
      findProjectResults,
      findStaffResults,
      noResultsMessage,
      noStaffResultsMessage,
      currentPage,
      currentTab,
      lawyerCaseStatus,
      lawyerCaseType,
      tabss,
      stringifyQuery: '',
    };
  }
  static summaryDefault = {
    count: 0,
    reservedCount: 0,
    bookedCount: 0,
    cancelledDeveloperCount: 0,
    pendingCancellationCount: 0,
    cancelledCount: 0,
    soldCount: 0,
    loanCount: 0,
  }
  constructor(props) {
    super(props);
    const state = BookingsList.getPropsToState(props);
    const summary = Object.assign({}, BookingsList.summaryDefault);
    this.state = {
      loading: true,
      count: 0,
      limit: 0,
      offset: 0,
      data: [],
      summary,
      ...state,
      mpUserLoading: false,
      mpUserDetails: {},
      isChanging: false,
      projectOpts: [],
      filteredProjects: [],
    };
  }
  componentDidMount() {
    const query = decodeSearch(this.props.location.search);
    this.fetchProjects();
    if (!isNumber(query.page) || query.page <= 0) {
      delete query.page;
    }
    const hasLawyerAccess = this.props.auth && this.props.auth.companyBranch && !this.props.auth.isExternalAgentLeader;
    const lawyerIsEnabled = this.props.appConfig && this.props.appConfig.data && this.props.appConfig.data.lawyerIsEnabled && hasLawyerAccess;
    const showLawyerTab = lawyerIsEnabled && !isCountryVietnam(this.props.auth.company.countryCode);
    const tabss = showLawyerTab ? tabs : tabs.filter(t => t.value !== 'aging_by_lawyers');
    if (query.tab && !tabss.some(t => t.value === query.tab)) {
      delete query.tab;
    }
    this.replaceQuery(query);
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillReceiveProps(nextProps) {
    const { currentTab } = this.state;
    const state = BookingsList.getPropsToState(nextProps);
    this.setState(state, () => {
      if (currentTab !== state.currentTab) {
        this.replaceQuery({
          tab: state.currentTab,
        }, true);
      }
    });
  }
  componentWillUnmount() {
    if (this.setTimer) {
      clearTimeout(this.setTimer);
    }
    if (this.setStaffTimer) {
      clearTimeout(this.setStaffTimer);
    }
    window.removeEventListener('resize', this.handleResize, false);
  }
  getStatusCount = (status) => {
    const { summary } = this.state;
    if (this.state.loading) {
      return '...';
    }
    switch (status) {
      case 'total':
        return summary.count;
      case 'reserved':
        return summary.reservedCount;
      case 'booked':
        return summary.bookedCount;
      case 'pending_cancellation':
        return summary.pendingCancellationCount || 0;
      case 'cancelled_developer':
        return summary.cancelledDeveloperCount;
      case 'cancelled_availability':
        return summary.cancelledCount;
      case 'sold_spa_signed':
        return summary.soldCount;
      case 'expired':
        return summary.expiredCount || 0;
      default:
        return 0;
    }
  }
  getSelectedStatus = (status) => {
    const { bookingStatus } = this.state;
    if (status === 'total') {
      return bookingStatus === '';
    } else if (bookingStatus !== '') {
      return bookingStatus === status;
    }
    return false;
  }
  getTabHeader = () => {
    const { currentTab } = this.state;
    const { t } = this.props;
    return t(tabs.find(tab => currentTab === tab.value).header);
  }
  getBankCaseStatusColor = (status) => {
    if (status.startsWith('reject')) {
      return 'red';
    } else if (status.startsWith('pending')) {
      return 'yellow';
    } else if (status.startsWith('approved') || status.startsWith('success')) {
      return 'green';
    }
    return 'blue';
  }
  getBankCaseStatuses = (data) => {
    const values = [];
    if (data.bankCasesStatuses) {
      data.bankCasesStatuses.forEach((bcs) => {
        values.push({
          iconColor: this.getBankCaseStatusColor(bcs.status),
          value: bcs.bankShortName,
        });
      });
    }
    return values;
  }
  setMPUserLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ mpUserLoading: loading }, () => {
        res(loading);
      });
    });
  }
  setLoadingProjectSearch(loadingProjectSearch = false) {
    return new Promise((res) => {
      this.setState({ loadingProjectSearch }, res);
    });
  }
  setLoadingStaffSearch(loadingStaffSearch = false) {
    return new Promise((res) => {
      this.setState({ loadingStaffSearch }, res);
    });
  }
  setBookings(data = []) {
    return new Promise((res) => {
      this.setState({
        data: data || [],
      }, () => {
        res(data);
      });
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        if (this.props.onLoading) {
          this.props.onLoading(loading);
        }
        res(loading);
      });
    });
  }
  getRowClassName = (statusID) => {
    if (statusID === 'cancelled_availability') {
      return 'row-colors booking_row_cancelled_availability';
    }
    if (statusID === 'cancelled_developer' || statusID === DEVELOPER_CANCELLED) {
      return 'row-colors booking_row_cancelled_developer';
    }
    return 'row-colors';
  }
  getAgingColor = (days = 0) => {
    if (days >= 30) {
      return 'red';
    }
    if (days >= 14) {
      return 'yellow';
    }
    return null;
  }
  getAllFilterNames = (removeBookingStatus = false) => {
    if (removeBookingStatus) return allFilterNames.filter(fn => fn !== 'bookingStatusMulti');
    return allFilterNames;
  }
  async fetchProjects() {
    const { store } = this.context;
    const { t } = this.props;
    const query = Object.assign({
      limit: 0,
      showAsOptions: true,
    });
    await this.setLoadingProjectSearch(true);
    let res;

    try {
      res = await store.dispatch(fetchM(`/projects/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 399 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      await this.setLoadingProjectSearch(false);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const data = await res.json();
      let newProjectOpts = this.state.projectOpts;
      if (data && data.length > 0) {
        newProjectOpts = data.map(d => ({ value: d.id, text: d.name }));
      }

      await this.setComponentState({ projectOpts: newProjectOpts });
    }
    await this.setLoadingProjectSearch(false);
  }
  async fetchBookings(q = {}) {
    await this.setLoading(true);
    const { t } = this.props;
    const { store } = this.context;
    const query = Object.assign(q, this.props.where || {});

    let res;

    if (this.props.appConfig && this.props.appConfig.data && this.props.appConfig.data.lawyerIsEnabled && this.state.currentTab === 'aging_by_lawyers') {
      if (query.projectFilter) {
        query.project_code = atob(query.projectFilter);
        delete query.projectFilter;
      }
      if (this.props.projectUnitID) {
        query.project_unit_id = this.props.projectUnitID;
      }
      if (this.props.appConfig && this.props.appConfig.data) {
        query.company_id = this.props.appConfig.data.companyID;
      }
      const limit = 10;
      query.limit = limit;
      query.from = (query.page - 1) * limit;
      delete query.tab;
      delete query.page;
      if (query.lawyerCaseStatus) {
        query.status = query.lawyerCaseStatus;
        delete query.lawyerCaseStatus;
      }
      if (query.lawyerCaseType) {
        query.type = query.lawyerCaseType;
        delete query.lawyerCaseType;
      }
      if (query.agingDuration && query.agingDuration.startsWith('more_than_')) {
        query.duration = parseInt(query.agingDuration.replace('more_than_', '').replace('_days', ''), 10);
        delete query.agingDuration;
      }
      if (query.searchIn === 'lawyer') {
        query.lawyer = query.search;
        delete query.search;
      }
      if (query.searchIn === 'firm') {
        query.firm = query.search;
        delete query.search;
      }
      try {
        res = await store.dispatch(fetchAPI('lawyerAPI', `${endpoints.BOOKING_AGING_CASES}/?${qs.stringify(query)}`, null, 'get', {
          'X-Api-Token': process.env.LAWYER_API_TOKEN,
        }));
      } catch (e) {
        Bugsnag.notifyException(e);
        await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
        await this.setLoading(false);
        return;
      }

      if (res) {
        const stringifyQuery = qs.stringify(query);
        const count = res.total_hits;
        const offset = query.from;
        await this.setBookings(res.items);
        if (this.props.hideBookingList) {
          this.props.bookingListLength(this.state.data.length);
        }
        if (this.state.data.length < 1 && query.from >= limit) {
          const que = decodeSearch(this.props.location.search);
          await this.setComponentState({
            offset: 0,
          });
          que.page = 1;
          this.replaceQuery(que);
        } else {
          // handle token.. etc
          await this.setComponentState({
            count,
            limit,
            offset,
            stringifyQuery,
          });
        }
      }

      await this.setLoading(false);
      return;
    }

    if (this.props.projectUnitID) {
      query.projectUnitID = this.props.projectUnitID;
    }

    const url = `/bookings/?${qs.stringify(query)}`;
    const urlOptions = {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    try {
      if (this.state.currentTab === 'aging_by_bankers') {
        res = await fetchWithCacheSWR(
          store,
          url,
          urlOptions,
          15000, // current ttl
          null,
          'ttl',
          'localStorage',
        );
      } else {
        res = await store.dispatch(fetchM(url, urlOptions));
      }
    } catch (err) {
      if (err.res && err.res.status >= 399 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const limit = parseInt(res.headers.get('M-Data-limit'), 10);
      const offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
      const data = await res.json();
      await this.setBookings(data);
      if (this.props.hideBookingList) {
        this.props.bookingListLength(this.state.data.length);
      }
      if (this.state.data.length < 1 && query.page > 1) {
        const que = decodeSearch(this.props.location.search);
        que.page = 1;
        this.replaceQuery(que);
      } else {
        // handle token.. etc
        await this.setComponentState({
          count,
          limit,
          offset,
        });
      }
    }
    await this.setLoading(false);
  }
  async fetchBookingSummaries(q = {}) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const query = Object.assign(q, this.props.where || {});
    if (this.props.projectUnitID) {
      query.projectUnitID = this.props.projectUnitID;
    }
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/summary/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const summary = await res.json();
      // handle token.. etc
      await this.setComponentState({ summary });
    }
  }
  fetchMarketplaceUserDetails = async (userID) => {
    const { store } = this.context;
    const { t } = this.props;
    const url = `/marketplace/staffs/${userID}/`;
    try {
      await this.setMPUserLoading(true);
      const response = await serverRequestGet(
        url,
        store,
      );
      if (response.error) {
        await store.dispatch(flashErrorMessage({ message: response.message }));
        return;
      }
      await this.setState({ mpUserDetails: response.data });
      await this.setMPUserLoading(false);
    } catch (e) {
      Bugsnag.notifyException(e);
      await this.setMPUserLoading(false);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
    }
  }
  handleResize = () => {
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < 768;
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile });
    }
  }
  hasAccess(check = false) {
    if (
      this.props.auth.isBranchLeader ||
      this.props.auth.isHeadquarters ||
      this.props.auth.isSuperAdmin
    ) {
      return true;
    }
    return check;
  }
  hasAdminAccess(check = false) {
    if (
      this.props.auth.isHeadquarters ||
      this.props.auth.isSuperAdmin
    ) {
      return true;
    }
    return check;
  }
  hasInternalDEAccess(check = false) {
    const auth = this.props.auth;
    if (auth && auth.companyBranch && !auth.companyBranch.isExternal) {
      return true;
    }
    return check;
  }
  hasStaffAccess(check = false) {
    if (
      this.props.auth.isSuperAdmin ||
      this.props.auth.isHeadquarters
    ) {
      return true;
    }
    return check;
  }
  handleChangePage = (currentPage) => {
    const query = decodeSearch(this.props.location.search);
    query.page = currentPage;
    this.setState({ currentPage }, () => {
      this.replaceQuery(query);
    });
  }
  handleSortData = (sortColumn, sortDirection) => {
    const query = decodeSearch(this.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    this.replaceQuery(query, true);
  }
  handleClearFilter = (...queryArray) => {
    let hasQuery = false;
    let clearSearch = false;
    const query = decodeSearch(this.props.location.search);
    const filterArray = [...queryArray];
    filterArray.forEach((filter) => {
      if (filter === 'search') {
        clearSearch = true;
      }
      if (filter === 'agingRange' || filter === 'loanStatus') {
        delete query.sortColumn;
        delete query.sortDirection;
      }
      if (filter === 'filteredProjects') {
        delete query.projectCode;
        delete query.projectFilter;
        hasQuery = true;
        this.setState({
          filteredProjects: [],
          isChanging: false,
        });
      }
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
        this.setState({ isChanging: false });
      }
    });
    const cb = () => {
      if (hasQuery) {
        this.replaceQuery(query, true);
      }
    };
    if (clearSearch) {
      this.setState({ search: '' }, () => {
        cb();
      });
    } else {
      cb();
    }
  }
  handleFilterOnChange = (value, queryName) => {
    const query = decodeSearch(this.props.location.search);
    query[queryName] = value;
    if (queryName === 'agingRange' || queryName === 'loanStatus') {
      delete query.sortColumn;
      delete query.sortDirection;
    }
    if (queryName === 'lawyerCaseType' && !getLawyerCaseStatuses(value).some(s => s.value === query.lawyerCaseStatus)) {
      delete query.lawyerCaseStatus;
    }
    let refetch = queryName !== 'searchIn' || (queryName === 'searchIn' && this.state.search.length > 0);
    if (queryName === 'dateRange' && query.dateRange === 'custom' && (!query.dateFrom || !query.dateTo)) {
      refetch = false;
    }
    if (queryName === 'cancelledDateRange' && query.cancelledDateRange === 'custom' && (!query.cancelledDateFrom || !query.cancelledDateTo)) {
      refetch = false;
    }
    if (queryName === 'expiredDateRange' && query.expiredDateRange === 'custom' && (!query.expiredDateFrom || !query.expiredDateTo)) {
      refetch = false;
    }
    if (queryName === 'bookedDateRange' && query.bookedDateRange === 'custom' && (!query.bookedDateFrom || !query.bookedDateTo)) {
      refetch = false;
    }
    if (queryName === 'soldDateRange' && query.soldDateRange === 'custom' && (!query.soldDateFrom || !query.soldDateTo)) {
      refetch = false;
    }
    this.replaceQuery(query, true, refetch);
  }
  handleSetDateRange = (name, from, to) => {
    const query = decodeSearch(this.props.location.search);
    switch (name) {
      case 'dateRange':
        query.dateFrom = from;
        query.dateTo = to;
        break;
      case 'cancelledDateRange':
        query.cancelledDateFrom = from;
        query.cancelledDateTo = to;
        break;
      case 'expiredDateRange':
        query.expiredDateFrom = from;
        query.expiredDateTo = to;
        break;
      case 'bookedDateRange':
        query.bookedDateFrom = from;
        query.bookedDateTo = to;
        break;
      case 'soldDateRange':
        query.soldDateFrom = from;
        query.soldDateTo = to;
        break;
      default:
        break;
    }
    this.replaceQuery(query, true);
  }
  handleReplaceStatus = (status = '') => {
    const query = decodeSearch(this.props.location.search);
    if (status !== '') {
      query.bookingStatus = status;
    } else {
      delete query.bookingStatus;
    }
    if (status !== 'cancelled_developer') {
      delete query.cancelledDateRange;
      delete query.cancelledDateFrom;
      delete query.cancelledDateTo;
    }
    if (status !== 'expired') {
      delete query.expiredDateRange;
      delete query.expiredDateFrom;
      delete query.expiredDateTo;
    }
    if (status !== 'booked') {
      delete query.bookedDateRange;
      delete query.bookedDateFrom;
      delete query.bookedDateTo;
    }
    if (status !== 'sold_spa_signed') {
      delete query.soldDateRange;
      delete query.soldDateFrom;
      delete query.soldDateTo;
    }
    this.replaceQuery(query);
  }
  handleSearchStaff = (value) => {
    const { t } = this.props;
    clearTimeout(this.setStaffTimer);
    const findStaffResults = [];
    const noStaffResultsMessage = `${t('Loading', { ns: TRANSLATION_FILES.translation })}...`;
    this.setState({ findStaffResults, noStaffResultsMessage, staffFilter: value }, () => {
      if (value !== '') {
        this.setStaffTimer = setTimeout(() => {
          this.searchStaffs(value);
        }, 500);
      }
    });
  }
  handleFilterProjects = (e, { name, value }) => {
    const { currentTab } = this.state;
    const isCurrentTabLawyer = currentTab === 'aging_by_lawyers';
    const filteredProjects = isCurrentTabLawyer ? [value] : value;
    this.setState({ filteredProjects }, () => {
      const query = decodeSearch(this.props.location.search);
      query[name] = btoa(value);
      this.replaceQuery(query, true);
    });
  }
  handleSelectProject = (project, queryName) => {
    const query = decodeSearch(this.props.location.search);
    const internalQuery = {};
    internalQuery.id = project.key;
    internalQuery.name = project.title;
    query[queryName] = btoa(qs.stringify(internalQuery));
    this.replaceQuery(query, true);
  }
  handleSelectStaff = (staff, queryName) => {
    const query = decodeSearch(this.props.location.search);
    const internalQuery = {};
    internalQuery.id = staff.key;
    internalQuery.name = staff.title;
    query[queryName] = btoa(qs.stringify(internalQuery));
    this.replaceQuery(query, true);
  }
  async searchStaffs(value) {
    const { store } = this.context;
    const { t } = this.props;
    await this.setLoadingStaffSearch(true);
    let res = null;
    try {
      res = await store.dispatch(fetchM(`/search/staffs/?isExternal=false&limit=3&search=${value}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      await this.setLoadingStaffSearch(false);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
    }
    if (!res.ok) {
      await this.setLoadingStaffSearch(false);
      throw new Error('Not OK');
    } else {
      await this.setLoadingStaffSearch(false);
      const json = await res.json();
      if (json) {
        const findStaffResults = json.map((obj) => {
          const newResults = {};
          newResults.key = obj.id.toString();
          newResults.title = obj.name;
          newResults.price = obj.preferredName;
          newResults.description = obj.email;
          return newResults;
        });
        this.setState({ findStaffResults });
      } else {
        const noStaffResultsMessage = `${t('No results found', { ns: TRANSLATION_FILES.translation })}.`;
        this.setState({ noStaffResultsMessage });
      }
    }
  }
  replaceQuery(query, resetPage = false, fetch = true) {
    const { store } = this.context;
    const { pathname, search } = this.props.location;
    const queryNew = query;
    if (resetPage) {
      queryNew.page = 1;
    }
    const bookingStatus = decodeSearch(search).bookingStatus;
    const bookingStatusMulti = decodeSearch(search).bookingStatusMulti;
    const paymentStatus = decodeSearch(search).paymentStatus;
    const lawyerCaseType = decodeSearch(search).lawyerCaseType;
    const lawyerCaseStatus = decodeSearch(search).lawyerCaseStatus;
    if (
      (query.bookingStatus && !bookingStatus) ||
      (query.bookingStatusMulti && !bookingStatusMulti) ||
      (query.paymentStatus && !paymentStatus) ||
      (query.lawyerCaseStatus && !lawyerCaseStatus) ||
      (query.lawyerCaseType && !lawyerCaseType)
    ) {
      queryNew.page = 1;
    }
    if (fetch) {
      this.fetchBookings(queryNew);
      if (this.state.currentTab === 'all') {
        this.fetchBookingSummaries(queryNew);
      }
    }
    store.dispatch(replace(`${pathname}?${encodeSearch(queryNew)}`));
  }
  exportURL = (fileType, primary = false, detailed = false) => {
    const { location, projectUnitID } = this.props;
    let url = `${config.get('bookApiURL')}/reports/bookings/`;
    if (location && location.search) {
      url += `${location.search}`;
    }
    if (projectUnitID) {
      url += `&projectUnitID=${projectUnitID}`;
    }
    if (primary) {
      url += '&primaryOnly=true';
    }
    url += `&fileType=${fileType}`;
    if (detailed) {
      url += '&detailed=true';
    }
    return url;
  }
  getDataTarget = idx => ({ 'data-bot-target': `row${idx + 1}-bookinglist` });
  getDatasetAttributes = (daname, davalue) => {
    let newDavalue = davalue;
    if (newDavalue === '') newDavalue = 'NULL';
    if (newDavalue === 'Not Applicable') newDavalue = 'N/A';
    const datasetName = `data-bot-${daname}`;
    return {
      [datasetName]: newDavalue,
    };
  }
  // CPI-1209 (PO, 5 Sep): the Booking ID column on this copy of the table, from utils/vietnam.
  showBookingIDColumn = () => vnShowBookingIDColumn(this.props.auth)
  showProjectColumn = () => isCountryVietnam(this.props.auth.company.countryCode)
  showPendingCancellation = () => isCountryVietnam(this.props.auth.company.countryCode)
  handleChangeTab = (e, { name, value }) => {
    const currentTab = name || value;
    this.setState({
      currentTab,
      data: [],
      filteredProjects: [],
      offset: 0,
      count: 0,
      limit: 0,
    }, () => {
      if (this.props.isUnitOverview) {
        this.replaceQuery({
          tab: currentTab,
          section: 'bookings',
        }, true);
      } else {
        this.replaceQuery({
          tab: currentTab,
        }, true);
      }
    });
  }
  agingRanges = [
    {
      value: 'all',
      text: 'All',
      sortColumn: 'aging_summary.current_age',
    },
    {
      value: 'reserved_to_today',
      text: 'Reserved To Today',
      sortColumn: 'aging_summary.reserved_to_today_age',
    },
    {
      value: 'reserved_to_booked',
      text: 'Reserved To Booked',
      sortColumn: 'aging_summary.booked_age',
    },
    {
      value: 'reserved_to_sold',
      text: 'Reserved To Sold',
      sortColumn: 'aging_summary.reserved_to_sold_age',
    },
    {
      value: 'booked_to_today',
      text: 'Booked To Today',
      sortColumn: 'aging_summary.booked_to_today_age',
    },
    {
      value: 'booked_to_sold',
      text: 'Booked To Sold',
      sortColumn: 'aging_summary.sold_age',
    },
  ];
  loanStatuses = [
    {
      value: 'new',
      text: 'New',
      sortColumn: 'summary.current_age',
    },
    {
      value: 'pending_docs',
      text: 'Pending Docs',
      sortColumn: 'summary.current_age',
    },
    {
      value: 'pending_docs_submitted',
      text: 'Docs Submitted',
      sortColumn: 'summary.current_age',
    },
    {
      value: 'approved_lo_issued',
      text: 'LO Approved',
      sortColumn: 'summary.current_age',
    },
    {
      value: 'success_li_issued',
      text: 'LO Signed',
      sortColumn: 'summary.created_to_success_li_issued_age',
    },
    {
      value: 'reject_unqualified',
      text: 'Unqualified',
      sortColumn: 'summary.created_to_reject_unqualified_age',
    },
    {
      value: 'reject_bank',
      text: 'Bank Rejected',
      sortColumn: 'summary.created_to_reject_bank_age',
    },
    {
      value: 'reject_customer',
      text: 'Customer Rejected',
      sortColumn: 'summary.created_to_reject_customer_age',
    },
    {
      value: 'reject_cancelled',
      text: 'Customer Cancelled',
      sortColumn: 'summary.created_to_reject_cancelled_age',
    },
    {
      value: 'reject_lo_signed_other_bank',
      text: 'LO Signed With Another Bank',
      sortColumn: 'summary.created_to_reject_lo_signed_other_bank_age',
    },
    {
      value: 'reject_developer',
      text: 'Developer Cancelled',
      sortColumn: 'summary.created_to_reject_developer_age',
    },
  ];
  hasMPDetailsAccess = () => {
    const { auth } = this.props;
    return auth.isHeadquarters || auth.isBranchLeaderSupervisor;
  }
  cellCheckSorted = (column, isReversed = false) => {
    const { sortColumn, sortDirection } = decodeSearch(this.props.location.search);
    const { currentTab } = this.state;
    // API default sorted by created at descending
    if (!sortColumn) {
      if (
        (currentTab === 'all' && column === 'booking.created_at') ||
        (currentTab === 'aging_by_units' && this.agingRanges.some(age => age.sortColumn === column)) ||
        (currentTab === 'aging_by_bankers' && (this.loanStatuses.some(status => status.sortColumn === column) || column === 'summary.current_age')) ||
        (currentTab === 'aging_by_lawyers' && column === 'aging_days')
      ) {
        return 'descending';
      }
    }
    if (column === sortColumn) {
      if (isReversed) {
        return sortDirection === 'asc' ? 'descending' : 'ascending';
      }
      return sortDirection === 'asc' ? 'ascending' : 'descending';
    }
    return null;
  }
  handleCellSort = (column) => {
    const query = decodeSearch(this.props.location.search);
    const { sortColumn, sortDirection } = query;
    const { currentTab } = this.state;
    let direction = 'asc';
    if (!sortColumn && currentTab === 'aging_by_lawyers' && column === 'aging_days') {
      direction = 'desc';
    } else if (column === sortColumn) {
      direction = sortDirection === 'asc' ? 'desc' : 'asc';
    }
    this.handleSortData(column, direction);
  }
  handleGetDaysSortColumn = () => {
    if (this.state.currentTab === 'aging_by_bankers') {
      if (this.loanStatuses.some(status => status.value === this.state.loanStatus)) {
        return this.loanStatuses.find(status => status.value === this.state.loanStatus).sortColumn;
      }
      return this.loanStatuses[0].sortColumn;
    }
    if (this.agingRanges.some(age => age.value === this.state.agingRange)) {
      return this.agingRanges.find(age => age.value === this.state.agingRange).sortColumn;
    }
    return this.agingRanges[0].sortColumn;
  }
  exportItemsAdmin = () => {
    if (this.hasAdminAccess() && this.state.currentTab !== 'aging_by_bankers') {
      const { location, projectUnitID } = this.props;
      let url = `${config.get('bookApiURL')}/reports/bookings/customer_details/`;
      if (location && location.search) {
        url += `${location.search}`;
      }
      if (projectUnitID) {
        url += `&projectUnitID=${projectUnitID}`;
      }
      return [
        {
          text: 'Excel\nwith\nCustomer\nDetails',
          icon: 'download',
          href: `${url}&fileType=excel`,
        },
        {
          text: 'Excel\n(primary)\nwith\nCustomer\nDetails',
          icon: 'download',
          href: `${url}&fileType=excel&primaryOnly=true`,
        },
        {
          text: 'CSV\nwith\nCustomer\nDetails',
          icon: 'download',
          href: `${url}&fileType=csv`,
        },
        {
          text: 'CSV\n(primary)\nwith\nCustomer\nDetails',
          icon: 'download',
          href: `${url}&fileType=csv&primaryOnly=true`,
        },
      ];
    }
    return [];
  }
  exportItemsPrimary = () => {
    if (this.state.currentTab !== 'aging_by_bankers') {
      return [
        {
          text: 'Excel\n(primary)',
          icon: 'download',
          href: this.exportURL('excel', true),
        },
        {
          text: 'CSV\n(primary)',
          icon: 'download',
          href: this.exportURL('csv', true),
        },
      ];
    }
    return [];
  }
  exportItemsManager = () => {
    const isMalaysia = this.props.auth.company && this.props.auth.company.countryCode === 'my';
    if (this.hasAccess() && this.state.currentTab !== 'aging_by_bankers') {
      const query = decodeSearch(this.props.location.search);
      query.page = 'all';
      const exportItems = [
        {
          text: 'Full\nExcel',
          icon: 'download',
          href: `${config.get('bookApiURL')}/bookings/export/?${qs.stringify(query)}`,
          dataTarget: 'fullexcel',
        },
        {
          text: 'Updated Today',
          icon: 'download',
          href: `${config.get('bookApiURL')}/bookings/export/?page=all&updatedToday=true`,
          dataTarget: 'updatedtoday',
        },
        {
          isDivider: true,
        },
      ];
      if (this.state.currentTab === 'all' && isMalaysia) {
        exportItems.push(
          {
            text: 'Loan Approval',
            icon: 'download',
            href: `${config.get('bookApiURL')}/bookings/export/loan_approvals/?${qs.stringify(query)}`,
            dataTarget: 'loanapproval',
          },
          {
            text: 'Booking Notes',
            icon: 'download',
            href: `${config.get('bookApiURL')}/bookings/export/notes/?${qs.stringify(query)}`,
            dataTarget: 'bookingnotes',
          },
          {
            isDivider: true,
          },
        );
      }
      return exportItems;
    }
    return [];
  }
  isShowLoanReminderLetter(data = {}) {
    const criteria = this.state.currentTab === 'aging_by_units' &&
      data.project.printLoanReminderType !== '' &&
      (data.bookingStatus.id === 'booked' || data.bookingStatus.id === 'reserved') &&
      this.checkGroupAccess(this.props.auth.groups) &&
      data.currentAge >= 14 &&
      data.currentAge <= 42;

    return criteria;
  }
  isShowSpaReminderLetter(data = {}) {
    const criteria = this.state.currentTab === 'aging_by_units' &&
      data.project.printSPAType !== '' &&
      (data.bookingStatus.id === 'booked' || data.bookingStatus.id === 'reserved') &&
      this.checkGroupAccess(this.props.auth.groups) &&
      data.currentAge >= 28;

    return criteria;
  }
  isShowTerminationLetter(data = {}) {
    const criteria = this.state.currentTab === 'aging_by_units' &&
      data.project.printTerminationType !== '' &&
      data.bookingStatus.id === 'sold_spa_signed' &&
      this.checkGroupAccess(this.props.auth.groups) &&
      data.currentAge >= 21;

    return criteria;
  }
  checkGroupAccess = (groups) => {
    const roles = [
      { text: 'Headquarters', value: '10,6' },
      { text: 'Supervisor', value: '10,11,12,13' },
      { text: 'Sales Manager', value: '10,11,13' },
      { text: 'Sales Admin', value: '10,11' },
    ];
    const rolesArr = [];
    if (groups) {
      groups.forEach((g) => {
        rolesArr.push(g.id);
      });
      rolesArr.sort();
      const role = roles.find(g => g.value === String(rolesArr.toString()));
      if (role && role.text) {
        return role.text;
      }
    }
    return null;
  }
  hasLawyerSPASignedDate = (date) => {
    if (date) {
      if (date.length > 1 && date[1]) {
        return true;
      }
    }
    return false;
  }
  handlePrint = () => {
    Auth.currentSession();
  }
  statusDateSortItems = () => {
    const { bookingStatus } = this.state;
    let label = '';
    let column = '';
    switch (bookingStatus) {
      case 'cancelled_developer':
        label = 'Cancelled';
        column = 'l_cancelled_developer_at';
        break;
      case 'expired':
        label = 'Expired';
        column = 'l_expired_at';
        break;
      case 'booked':
        label = 'Booked';
        column = 'l_booked_at';
        break;
      case 'sold_spa_signed':
        label = 'Sold';
        column = 'l_sold_at';
        break;
      default:
        break;
    }
    return !this.props.projectUnitID && column ? [
      {
        text: `${label} Date Ascending`,
        icon: 'sort alphabet ascending',
        sortColumn: `booking.${column}`,
        sortDirection: 'asc',
      },
      {
        text: `${label} Date Descending`,
        icon: 'sort alphabet descending',
        sortColumn: `booking.${column}`,
        sortDirection: 'desc',
      },
    ] : [];
  }
  bookingNoteToMarkdown = (bNote) => {
    try {
      const hasNoSpaces = bNote.indexOf(' ') === -1;
      if (hasNoSpaces) {
        return decodeURIComponent(bNote.replace(/\+/g, ' '));
      }
      return decodeURIComponent(bNote);
    } catch (e) {
      return bNote;
    }
  };
  bookingNoteToEditorState = (bookingNote) => {
    const mdValue = this.bookingNoteToMarkdown(bookingNote);
    if (mdValue) {
      const rawData = markdownToDraft(mdValue, {
        preserveNewlines: true,
        blockStyles: {
          ins_open: 'UNDERLINE',
        },
        remarkableOptions: {
          enable: {
            inline: 'ins',
          },
        },
      });
      const contentState = convertFromRaw(rawData);
      const editorState = EditorState.createWithContent(contentState);
      return editorState;
    }
    return EditorState.createEmpty();
  }
  bookingNoteFormated = (bookingData) => {
    if (!bookingData) return '';
    if (!bookingData.latestBookingNote) return bookingData.remarkInternal; // deprecated old field
    // convert markdown to draft-js and then back to plaintext properly with custom formatings.
    const editorState = this.bookingNoteToEditorState(bookingData.latestBookingNote);
    const contentState = editorState.getCurrentContent();
    let plainText = contentState.getPlainText();
    const maxLength = 180;
    if (plainText && plainText.length > maxLength) {
      plainText = `${plainText.substring(0, maxLength)}...`;
    }
    return plainText;
  }
  hasBookingNote = (bookingData) => {
    if (bookingData && (bookingData.latestBookingNote || bookingData.remarkInternal)) return true;
    return false;
  }
  renderStatusDateFilter = () => {
    const { bookingStatus, loading } = this.state;
    let filter = '';
    let filterFrom = '';
    let filterTo = '';
    let headerText = '';
    switch (bookingStatus) {
      case 'cancelled_developer':
        filter = 'cancelledDateRange';
        filterFrom = 'cancelledDateFrom';
        filterTo = 'cancelledDateTo';
        headerText = 'Cancelled Date Range';
        break;
      case 'expired':
        filter = 'expiredDateRange';
        filterFrom = 'expiredDateFrom';
        filterTo = 'expiredDateTo';
        headerText = 'Expired Date Range';
        break;
      case 'booked':
        filter = 'bookedDateRange';
        filterFrom = 'bookedDateFrom';
        filterTo = 'bookedDateTo';
        headerText = 'Booked Date Range';
        break;
      case 'sold_spa_signed':
        filter = 'soldDateRange';
        filterFrom = 'soldDateFrom';
        filterTo = 'soldDateTo';
        headerText = 'Sold Date Range';
        break;
      default:
        break;
    }
    return filter && !this.props.projectUnitID && (
      <Grid.Column
        className="filter"
        mobile={8}
        tablet={5}
        computer={4}
      >
        <BookingDatePicker
          filterName={filter}
          filterNameFrom={filterFrom}
          filterNameTo={filterTo}
          headerText={headerText}
          placeholder={`Select ${headerText}`}
          dateFrom={this.state[filterFrom]}
          dateTo={this.state[filterTo]}
          onChange={this.handleFilterOnChange}
          onClose={this.handleClearFilter}
          onResetRange={this.handleClearFilter}
          onSetRange={(from, to) => this.handleSetDateRange(filter, from, to)}
          value={this.state[filter]}
          disabled={loading}
        />
      </Grid.Column>
    );
  }
  renderMenuTool = () => {
    const { projectUnitID, t } = this.props;
    const { currentTab, isMobile, loading, loadingProjectSearch, isChanging } = this.state;
    const isCurrentTabAll = currentTab === 'all';
    const isCurrentTabUnit = currentTab === 'aging_by_units';
    const isCurrentTabBanker = currentTab === 'aging_by_bankers';
    const isCurrentTabLawyer = currentTab === 'aging_by_lawyers';
    const searchAreas = isCurrentTabLawyer ? [
      { value: 'all', text: t('All', { ns: TRANSLATION_FILES.constants }) },
      { value: 'lawyer', text: t('Lawyer') },
      { value: 'firm', text: t('Law Firm') },
    ] : [
      { value: 'all', text: t('All', { ns: TRANSLATION_FILES.constants }) },
      { value: 'booking.assigned_ma_preferred_name', text: t('Assigned staff') },
      { value: isCurrentTabBanker ? 'affiliate.name' : 'booking.ma_created_by_preferred_name', text: isCurrentTabBanker ? t('Reserved by') : createdByLabel(this.props.auth, t, t('Reserved by')) },
      { value: isCurrentTabBanker ? 'company_branch.name' : 'booking.ma_user_affiliate_company_branch_short_name', text: t('Business Unit') },
      // { value: 'booking.affiliate_name', text: 'Agent' },
      // { value: 'booking.agency_name', text: 'Agency' },
    ];
    if (isCurrentTabBanker) {
      searchAreas.push(
        { value: 'bankers.name', text: t('Banker') },
        { value: 'banks.name,banks.short_name', text: t('Bank') },
      );
    }
    const statusTabs = bookingStatusesTabs(this.showPendingCancellation());
    return (
      <Grid.Row className="toolbar">
        {
          isCurrentTabAll ? (
            <Grid.Column width={16}>
              <Grid
                className="status"
                columns="equal"
                textAlign="left"
                verticalAlign="middle"
                stretched
              >
                <Grid.Row>
                  {
                    statusTabs.map((status, key) => (
                      <FixedBarStatus
                        key={key}
                        status={status.value}
                        name={t(status.text, { ns: TRANSLATION_FILES.constants })}
                        count={this.getStatusCount(status.value)}
                        selected={this.getSelectedStatus(status.value)}
                        onClick={status.value === 'total' ? () => this.handleReplaceStatus() : this.handleReplaceStatus}
                      />
                    ))
                  }
                </Grid.Row>
              </Grid>
            </Grid.Column>
          ) : null
        }
        <Grid.Column width={16}>
          <Grid
            className="filters booking"
            columns="equal"
            textAlign="left"
            verticalAlign="middle"
          >
            <Grid.Row>
              {
                isCurrentTabAll ? (
                  <Grid.Column
                    className="filter"
                    mobile={projectUnitID ? 7 : 8}
                    tablet={projectUnitID ? 7 : 5}
                    computer={4}
                  >
                    <BookingDatePicker
                      filterName="dateRange"
                      filterNameFrom="dateFrom"
                      filterNameTo="dateTo"
                      headerText="Created Date Range"
                      placeholder="Select Created Date Range"
                      dateFrom={this.state.dateFrom}
                      dateTo={this.state.dateTo}
                      onChange={this.handleFilterOnChange}
                      onClose={this.handleClearFilter}
                      onResetRange={this.handleClearFilter}
                      onSetRange={(from, to) => this.handleSetDateRange('dateRange', from, to)}
                      value={this.state.dateRange}
                      disabled={loading}
                    />
                  </Grid.Column>
                ) : null
              }
              {this.renderStatusDateFilter()}
              {
                isCurrentTabAll ? (
                  <Grid.Column
                    className="filter"
                    mobile={projectUnitID ? 7 : 8}
                    tablet={projectUnitID ? 7 : 6}
                    computer={projectUnitID ? 4 : 3}
                  >
                    <BookingSelectListMultiple
                      filterName="bookingStatusMulti"
                      onChange={this.handleFilterOnChange}
                      onClose={this.handleClearFilter}
                      options={bookingStatusesAll(this.showPendingCancellation()).map(({ value, text }) => ({ value, text: t(text, { ns: TRANSLATION_FILES.constants }) }))}
                      placeholder={t('Booking Status')}
                      value={this.state.bookingStatusMulti}
                      disabled={loading}
                    />
                  </Grid.Column>
                ) : null
              }
              {
                isCurrentTabAll ? (
                  <Grid.Column
                    className="filter"
                    mobile={projectUnitID ? 7 : 8}
                    tablet={projectUnitID ? 7 : 6}
                    computer={projectUnitID ? 4 : 3}
                  >
                    <BookingSelectListMultiple
                      filterName="paymentStatus"
                      onChange={this.handleFilterOnChange}
                      onClose={this.handleClearFilter}
                      options={PAYMENT_STATUSES.map(({ value, text }) => ({ value, text: t(text, { ns: TRANSLATION_FILES.constants }) }))}
                      placeholder={t('Payment Status')}
                      value={this.state.paymentStatus}
                      disabled={loading}
                    />
                  </Grid.Column>
                ) : null
              }
              {
                !projectUnitID && (
                  <Grid.Column
                    className="filter"
                    mobile={isChanging ? 14 : 16}
                    tablet={isChanging ? 6 : 7}
                    computer={4}
                    style={(isCurrentTabAll && isMobile) ? { paddingTop: '0.5rem' } : null}
                  >
                    <Dropdown
                      disabled={loading || loadingProjectSearch}
                      fluid
                      loading={loadingProjectSearch}
                      multiple={!isCurrentTabLawyer}
                      name="projectFilter"
                      onChange={this.handleFilterProjects}
                      options={this.state.projectOpts}
                      placeholder={t('Find Project')}
                      search
                      selection
                      value={!isCurrentTabLawyer ? this.state.filteredProjects : this.state.filteredProjects[0] || ''}
                    />
                  </Grid.Column>
                )
              }
              {
                isCurrentTabUnit ? (
                  <Grid.Column
                    className="filter"
                    mobile={projectUnitID ? 7 : 8}
                    tablet={projectUnitID ? 7 : 4}
                    computer={projectUnitID ? 4 : 3}
                  >
                    <BookingSelectList
                      filterName="agingRange"
                      onChange={this.handleFilterOnChange}
                      onClose={this.handleClearFilter}
                      options={this.agingRanges.map(({ value, text }) => ({ value, text: t(text, { ns: TRANSLATION_FILES.constants }) }))}
                      placeholder={t('Aging Range')}
                      value={this.state.agingRange}
                      disabled={loading}
                    />
                  </Grid.Column>
                ) : null
              }
              {
                isCurrentTabBanker ? (
                  <Grid.Column
                    className="filter"
                    mobile={projectUnitID ? 7 : 8}
                    tablet={projectUnitID ? 7 : 4}
                    computer={projectUnitID ? 4 : 3}
                  >
                    <BookingSelectListMultiple
                      filterName="loanStatus"
                      onChange={this.handleFilterOnChange}
                      onClose={this.handleClearFilter}
                      options={this.loanStatuses.map(({ value, text }) => ({ value, text: t(text, { ns: TRANSLATION_FILES.constants }) }))}
                      placeholder={t('Loan Status')}
                      value={this.state.loanStatus}
                      disabled={loading}
                    />
                  </Grid.Column>
                ) : null
              }
              {
                isCurrentTabLawyer ? (
                  <Grid.Column
                    className="filter"
                    mobile={8}
                    tablet={4}
                    computer={3}
                  >
                    <BookingSelectList
                      filterName="lawyerCaseType"
                      onChange={this.handleFilterOnChange}
                      onClose={this.handleClearFilter}
                      options={LAWYER_CASE_TYPES.map(({ value, text }) => ({ value, text: t(text, { ns: TRANSLATION_FILES.constants }) }))}
                      placeholder={t('Case Type')}
                      value={this.state.lawyerCaseType}
                      disabled={loading}
                    />
                  </Grid.Column>
                ) : null
              }
              {
                isCurrentTabLawyer ? (
                  <Grid.Column
                    className="filter"
                    mobile={8}
                    tablet={4}
                    computer={3}
                    style={isMobile && !projectUnitID ? { paddingTop: '0.5rem' } : null}
                  >
                    <BookingSelectList
                      filterName="lawyerCaseStatus"
                      onChange={this.handleFilterOnChange}
                      onClose={this.handleClearFilter}
                      options={getLawyerCaseStatuses(this.state.lawyerCaseType).map(({ value, text }) => ({ value, text: t(text, { ns: TRANSLATION_FILES.constants }) }))}
                      placeholder={t('Case Status')}
                      value={this.state.lawyerCaseStatus}
                      disabled={loading}
                    />
                  </Grid.Column>
                ) : null
              }
              {
                currentTab !== 'all' ? (
                  <Grid.Column
                    className="filter"
                    mobile={!isCurrentTabLawyer && projectUnitID ? 7 : 8}
                    tablet={!isCurrentTabLawyer && projectUnitID ? 7 : 4}
                    computer={!isCurrentTabLawyer && projectUnitID ? 4 : 3}
                    style={isMobile && (!projectUnitID || (projectUnitID && isCurrentTabLawyer)) ? { paddingTop: '0.5rem' } : null}
                  >
                    <BookingSelectList
                      filterName="agingDuration"
                      onChange={this.handleFilterOnChange}
                      onClose={this.handleClearFilter}
                      options={AGING_DATE_RANGE.map(({ value, text }) => ({ value, text: t(text, { ns: TRANSLATION_FILES.constants }) }))}
                      placeholder={t('Duration')}
                      value={this.state.agingDuration}
                      disabled={loading}
                    />
                  </Grid.Column>
                ) : null
              }
              {
                isCurrentTabUnit ? (
                  <Grid.Column
                    className="filter"
                    mobile={projectUnitID ? 7 : 8}
                    tablet={projectUnitID ? 7 : 4}
                    computer={projectUnitID ? 4 : 3}
                  >
                    <BookingSelectListMultiple
                      filterName="bookingStatusMulti"
                      onChange={this.handleFilterOnChange}
                      onClose={this.handleClearFilter}
                      options={bookingStatusesAll(this.showPendingCancellation()).map(({ value, text }) => ({ value, text: t(text, { ns: TRANSLATION_FILES.constants }) }))}
                      placeholder={t('Booking Status')}
                      value={this.state.bookingStatusMulti}
                      disabled={loading}
                    />
                  </Grid.Column>
                ) : null
              }
              <Grid.Column
                className={`clear ${isCurrentTabLawyer && !projectUnitID ? 'tablet-hide mobile-hide' : ''}`}
                textAlign="center"
                verticalAlign="middle"
                mobile={!isCurrentTabLawyer && projectUnitID ? 2 : 2}
                tablet={!isCurrentTabLawyer && projectUnitID ? 2 : 1}
                computer={isCurrentTabLawyer ? (projectUnitID ? 2 : 3) : (projectUnitID ? 3 : 1)}
              >
                {
                  this.getAllFilterNames(false).some(filterName => this.state[filterName] &&
                  this.state[filterName].length > 0) ? (
                    <a onClick={() => this.handleClearFilter(...this.getAllFilterNames(false))}>
                      <Button size="small" color="red">
                        <Icon name="remove" fitted />
                      </Button>
                    </a>
                  ) : null
                }
              </Grid.Column>
              <Grid.Column
                mobile={!isCurrentTabBanker && !projectUnitID ? 13 : 16}
                tablet={isCurrentTabAll && !projectUnitID ? 8 : !isCurrentTabBanker && !projectUnitID ? 10 : 16}
                computer={!isCurrentTabBanker && !projectUnitID ? 16 : 5}
                style={(!projectUnitID && !isCurrentTabBanker) || (projectUnitID && isCurrentTabUnit) ? { paddingTop: '0.5rem' } : null}
              >
                <SearchIn
                  isLoading={loading}
                  onChange={this.handleFilterOnChange}
                  onSearchInChange={this.handleFilterOnChange}
                  onClear={this.handleClearFilter}
                  search={this.state.search}
                  searchIn={this.state.searchIn}
                  options={searchAreas}
                  isFullSize={!isCurrentTabBanker && !projectUnitID}
                />
              </Grid.Column>
              {
                !projectUnitID && isCurrentTabLawyer ? (
                  <Grid.Column
                    className="clear"
                    textAlign="right"
                    only="tablet mobile"
                    mobile={2}
                    tablet={1}
                  >
                    {
                      this.getAllFilterNames(false).some(filterName => this.state[filterName] &&
                      this.state[filterName].length > 0) ? (
                        <a onClick={() => this.handleClearFilter(...this.getAllFilterNames(false))}>
                          <Button size="small" color="red">
                            <Icon name="remove" fitted />
                          </Button>
                        </a>
                      ) : null
                    }
                  </Grid.Column>
                ) : null
              }
            </Grid.Row>
          </Grid>
        </Grid.Column>
      </Grid.Row>
    );
  }
  renderStatusDateCell = (isHeader, data = {}) => {
    const { t } = this.props;
    const { bookingStatus } = this.state;
    let label = '';
    let date = '';
    switch (bookingStatus) {
      case 'cancelled_developer':
        label = 'Cancelled';
        date = data.lastCancelledDeveloperAt;
        break;
      case 'expired':
        label = 'Expired';
        date = data.lastExpiredAt;
        break;
      case 'booked':
        label = 'Booked';
        date = data.lastBookedAt;
        break;
      case 'sold_spa_signed':
        label = 'Sold';
        date = data.lastSoldAt;
        break;
      default:
        break;
    }
    if (isHeader) {
      return (
        <span>
          {t('Created')}
          {
            !this.props.projectUnitID && label && (
              <span>
                &nbsp;&amp;
                <br />
                {t(label, { ns: TRANSLATION_FILES.constants })}
              </span>
            )
          }
        </span>
      );
    }
    return !this.props.projectUnitID && date && (
      <small>
        <Timestamp
          timestamp={date}
          format="DD/M/YYYY"
        />
        <br />
        <Timestamp
          timestamp={date}
          format="hh:mm a"
        />
      </small>
    );
  }
  renderTableHeaders = (sortItems) => {
    const { projectUnitID, t } = this.props;
    const { currentTab } = this.state;
    const isCurrentTabAll = currentTab === 'all';
    const isCurrentTabBanker = currentTab === 'aging_by_bankers';
    const isCurrentTabLawyer = currentTab === 'aging_by_lawyers';
    return (
      <Table.Header className="mobile-hide">
        <Table.Row>
          {
            !isCurrentTabAll ? (
              <Table.HeaderCell
                collapsing
                sorted={this.cellCheckSorted(sortItems[isCurrentTabLawyer ? 8 : 10].sortColumn, isCurrentTabLawyer)}
                onClick={() => this.handleCellSort(sortItems[isCurrentTabLawyer ? 8 : 10].sortColumn)}
              >{t('Days')}</Table.HeaderCell>
            ) : null
          }
          <Table.HeaderCell
            collapsing
            sorted={this.cellCheckSorted(sortItems[0].sortColumn)}
            onClick={() => this.handleCellSort(sortItems[0].sortColumn)}
          >{this.renderStatusDateCell(true)}</Table.HeaderCell>
          {
            this.showBookingIDColumn() ? (
              <Table.HeaderCell className="mobile-hide">{t('Booking ID', { ns: TRANSLATION_FILES.translation })}</Table.HeaderCell>
            ) : null
          }
          {
            this.showProjectColumn() ? (
              <Table.HeaderCell className="mobile-hide">{t('Project', { ns: TRANSLATION_FILES.screens })}</Table.HeaderCell>
            ) : null
          }
          {
            !projectUnitID ? (
              <Table.HeaderCell
                sorted={this.cellCheckSorted(sortItems[2].sortColumn)}
                onClick={() => this.handleCellSort(sortItems[2].sortColumn)}
              >{t('Unit')}</Table.HeaderCell>
            ) : null
          }
          {
            isCurrentTabAll ? (
              <Table.HeaderCell className="mobile-hide">{t('Customer')}</Table.HeaderCell>
            ) : null
          }
          {
            projectUnitID && isCurrentTabBanker ? (
              <Table.HeaderCell
                collapsing
                sorted={isCurrentTabLawyer ? null : this.cellCheckSorted(sortItems[16].sortColumn)}
                onClick={isCurrentTabLawyer ? null : () => this.handleCellSort(sortItems[16].sortColumn)}
              >{t('Code')}</Table.HeaderCell>
            ) : null
          }
          {
            !isCurrentTabBanker && !isCurrentTabLawyer && (
              <Table.HeaderCell collapsing>{t('Bank')}</Table.HeaderCell>
            )
          }
          {
            isCurrentTabLawyer && (
              <Table.HeaderCell
                sorted={this.cellCheckSorted(sortItems[10].sortColumn)}
                onClick={() => this.handleCellSort(sortItems[10].sortColumn)}
              >{t('Purchaser')}</Table.HeaderCell>
            )
          }
          {
            isCurrentTabLawyer && (
              <Table.HeaderCell
                sorted={this.cellCheckSorted(sortItems[6].sortColumn)}
                onClick={() => this.handleCellSort(sortItems[6].sortColumn)}
              >{t('Type')}</Table.HeaderCell>
            )
          }
          <Table.HeaderCell
            sorted={this.cellCheckSorted(sortItems[4].sortColumn)}
            onClick={() => this.handleCellSort(sortItems[4].sortColumn)}
          >{t('Status')}</Table.HeaderCell>
          {
            isCurrentTabBanker && (
              <Table.HeaderCell
                collapsing
                sorted={this.cellCheckSorted(sortItems[12].sortColumn)}
                onClick={() => this.handleCellSort(sortItems[12].sortColumn)}
              >{t('Banker')}</Table.HeaderCell>
            )
          }
          {
            isCurrentTabLawyer && (
              <Table.HeaderCell
                sorted={isCurrentTabLawyer ? null : this.cellCheckSorted(sortItems[4].sortColumn)}
                onClick={isCurrentTabLawyer ? null : () => this.handleCellSort(sortItems[4].sortColumn)}
              >{t('Lawyer')}</Table.HeaderCell>
            )
          }
          {
            isCurrentTabBanker && (
              <Table.HeaderCell
                collapsing
                sorted={this.cellCheckSorted(sortItems[14].sortColumn)}
                onClick={() => this.handleCellSort(sortItems[14].sortColumn)}
              >{t('Bank')}</Table.HeaderCell>
            )
          }
          {
            !isCurrentTabLawyer && (
              <Table.HeaderCell
                collapsing
                sorted={this.cellCheckSorted(sortItems[6].sortColumn)}
                onClick={() => this.handleCellSort(sortItems[6].sortColumn)}
              >{isCurrentTabBanker ? t('Reserved by') : createdByLabel(this.props.auth, t, t('Reserved by'))}</Table.HeaderCell>
            )
          }
          {
            !isCurrentTabLawyer && this.hasInternalDEAccess() ?
              <Table.HeaderCell
                collapsing
                sorted={this.cellCheckSorted(sortItems[8].sortColumn)}
                onClick={() => this.handleCellSort(sortItems[8].sortColumn)}
              >{t('Assigned staff')}</Table.HeaderCell>
            : null
          }
          <Table.HeaderCell />
          <Table.HeaderCell />
        </Table.Row>
      </Table.Header>
    );
  }
  renderTableRow = (data, idx) => {
    const {
      currentTab,
      mpUserLoading,
      mpUserDetails,
    } = this.state;
    const { t } = this.props;
    const isPendingCancellation = this.showPendingCancellation() && isBookingPendingCancellation(data);
    if (currentTab === 'aging_by_lawyers') {
      const statusOption = LAWYER_ALL_STATUSES.find(s => s.value === data.status);
      let status = '';
      if (statusOption) {
        status = t(statusOption.text, { ns: TRANSLATION_FILES.constants });
      }
      return (
        <Table.Row
          key={idx}
          className={this.getRowClassName(data.status)}
        >
          <Table.Cell collapsing className="days">
            <span className="mobile-hide">
              <Header
                color={this.getAgingColor(data.aging_days || 0)}
                content={data.aging_days || 0}
              />
            </span>
            <span className="computer-hide">
              <Link to={`/bookings/${data.booking_id}/`}>
                {(data.purchaser && data.purchaser.name) || ''}
                <Icon name="chevron right" style={{ float: 'right' }} />
              </Link>
            </span>
          </Table.Cell>
          <Table.Cell collapsing>
            <span className="mobile-hide">
              <Timestamp
                timestamp={data.created_at}
                format="DD/M/YYYY"
              />
              <br />
              <Timestamp
                timestamp={data.created_at}
                format="hh:mm a"
              />
            </span>
            {
              currentTab === 'all' && (
                <span className="computer-hide">
                  <Link to={`/bookings/${data.booking_id}/`}>
                    {(data.purchaser && data.purchaser.name) || ''}
                    <Icon name="chevron right" style={{ float: 'right' }} />
                  </Link>
                </span>
              )
            }
          </Table.Cell>
          {
            !this.props.projectUnitID ? (
              <Table.Cell>
                <Link title={data.code} to={`/bookings/${data.booking_id}/`}>
                  {data.property.unit_no}, {data.property.project_name}
                  {/* {data.projectUnit.isBumi && <Label size="mini" style={{ marginLeft: '0.5em' }}>Bumi</Label>} */}
                </Link>
                {
                  this.hasBookingNote(data) && (
                    <Popup
                      trigger={
                        <div className="mobile-hide" style={{ float: 'right', color: 'rgba(0,0,0,.5)' }}>
                          <Icon name="sticky note" color="grey" />
                        </div>
                      }
                      content={this.bookingNoteFormated(data)}
                      size="mini"
                      inverted
                    />
                  )
                }
              </Table.Cell>
            ) : null
          }
          <Table.Cell collapsing>
            <span className="mobile-hide">
              {data.purchaser.name}
            </span>
          </Table.Cell>
          <Table.Cell collapsing>
            <span className="mobile-hide">
              {data.type}
            </span>
          </Table.Cell>
          <Table.Cell collapsing>
            <span className="mobile-hide" title={this.hasLawyerSPASignedDate(data.status_updated_at) && data.type === 'SPA' && `SPA Signed At ${moment(data.status_updated_at[1]).format('DD-MM-YYYY, hh:mm a')}`}>
              {status}
              {
                this.hasLawyerSPASignedDate(data.status_updated_at) && data.type === 'SPA' && (
                  <Popup
                    trigger={
                      <div className="mobile-hide" style={{ float: 'right', color: 'rgba(0,0,0,.5)' }}>
                        <Icon name="sticky note" color="grey" />
                      </div>
                    }
                    content={`${t('SPA Signed At')} ${moment(data.status_updated_at[1]).format('DD-MM-YYYY, hh:mm a')}`}
                    size="mini"
                    inverted
                  />
                )
              }
            </span>
            <span className="computer-hide">
              <small>{status}</small>
            </span>
          </Table.Cell>
          <Table.Cell collapsing>
            <span className="mobile-hide">
              {data.lawyer.name}
            </span>
            <span className="computer-hide">
              <small>{data.lawyer.name}</small>
            </span>
          </Table.Cell>
          <Table.Cell collapsing>
            <span className="computer-hide">
              <small>
                <Timestamp
                  timestamp={data.created_at}
                  format="DD/M/YYYY"
                />
                <br />
                <Timestamp
                  timestamp={data.created_at}
                  format="hh:mm a"
                />
              </small>
              <Header
                floated="right"
                color={this.getAgingColor(data.aging_days || 0)}
                content={data.aging_days || 0}
              />
            </span>
          </Table.Cell>
          <Table.Cell collapsing textAlign="right">
            <span className="mobile-hide">
              <Link to={`/bookings/${data.booking_id}/`}>
                <Icon name="chevron right" />
              </Link>
            </span>
          </Table.Cell>
        </Table.Row>
      );
    }
    return (
      <Table.Row
        key={idx}
        className={this.getRowClassName(data.statusID)}
        {...this.getDataTarget(idx)}
        {...this.getDatasetAttributes('bookingid', data.id)}
        {...this.getDatasetAttributes('unitno', data.projectUnit.reference)}
        {...this.getDatasetAttributes('projectname', data.project.shortName)}
        {...this.getDatasetAttributes('purchasername', currentTab === 'aging_by_bankers' ? data.name : (data.bookingCustomer && data.bookingCustomer.name) || '')}
      >
        {
          currentTab !== 'all' ? (
            <Table.Cell collapsing className="days">
              <span className="mobile-hide">
                <Header
                  color={this.getAgingColor(data.currentAge)}
                  content={data.currentAge}
                />
              </span>
              <span className="computer-hide">
                <Link to={`/bookings/${data.id}/`}>
                  {
                    (currentTab === 'aging_by_bankers' ? data.name
                    : (data.bookingCustomer && data.bookingCustomer.name)) || ''
                  }
                  <Icon name="chevron right" style={{ float: 'right' }} />
                </Link>
              </span>
            </Table.Cell>
          ) : null
        }
        <Table.Cell collapsing>
          <span className="mobile-hide">
            <Timestamp
              timestamp={data.createdAt}
              format="DD/M/YYYY"
            />
            <br />
            <Timestamp
              timestamp={data.createdAt}
              format="hh:mm a"
            />
            <br />
            {this.renderStatusDateCell(false, data)}
          </span>
          {
            currentTab === 'all' && (
              <span className="computer-hide">
                <Link to={`/bookings/${data.id}/`}>
                  {data.bookingCustomer && data.bookingCustomer.name}
                  <Icon name="chevron right" style={{ float: 'right' }} />
                </Link>
              </span>
            )
          }
        </Table.Cell>
        {
          this.showBookingIDColumn() ? (
            <Table.Cell className="mobile-hide">{bookingIDCellValue(data)}</Table.Cell>
          ) : null
        }
        {
          this.showProjectColumn() ? (
            <Table.Cell className="mobile-hide">{(data.project && data.project.name) || '-'}</Table.Cell>
          ) : null
        }
        {
          !this.props.projectUnitID ? (
            <Table.Cell>
              <Link title={data.code} to={`/bookings/${data.id}/`}>
                {data.projectUnit.reference}, {data.project.shortName}
                {/* CPI-1269: Project > Unit's wording for the same is_bumi flag. */}
                {data.projectUnit.isBumi && <Label size="mini" style={{ marginLeft: '0.5em' }}>{unitQuotaChipLabel(this.props.auth, t)}</Label>}
                {data.origin && data.origin.includes('marketplace') && <Label size="mini" style={{ marginLeft: '0.5em', backgroundColor: '#e6fff2', color: '#008040' }}>{data.origin.includes('_') ? t('Showroom Buyer') : t('Marketplace')}</Label>}
                {data.buyerProfileID && data.buyerProfileID !== '' && <Label size="mini" style={{ marginLeft: '0.5em', backgroundColor: '#F5F6F7', color: '#586976' }}>{t('Buyer')}</Label>}
              </Link>
              {
                this.hasBookingNote(data) && (
                  <Popup
                    trigger={
                      <div className="mobile-hide" style={{ float: 'right', color: 'rgba(0,0,0,.5)' }}>
                        <Icon name="sticky note" color="grey" />
                      </div>
                    }
                    content={this.bookingNoteFormated(data)}
                    size="mini"
                    inverted
                  />
                )
              }
            </Table.Cell>
          ) : null
        }
        {
          currentTab === 'all' ? (
            <Table.Cell className="mobile-hide">
              <Link title={data.code} to={`/bookings/${data.id}/`}>
                {data.bookingCustomer && data.bookingCustomer.name}
              </Link>
            </Table.Cell>
          ) : null
        }
        {
          this.props.projectUnitID && currentTab === 'aging_by_bankers' ? (
            <Table.Cell collapsing>
              <span className="mobile-hide">
                <Link to={`/bookings/${data.id}/`}>
                  {data.code}
                </Link>
              </span>
              <span className="computer-hide">
                {data.code}
              </span>
            </Table.Cell>
          ) : null
        }
        {
          currentTab !== 'aging_by_bankers' && (
            <Table.Cell collapsing>
              <span className="mobile-hide">
                {
                  data.loanTrackerLeadID > 0 ?
                    (
                      data.bankCaseCount > 0 ?
                        <PopupButtonList
                          size="tiny"
                          data={this.getBankCaseStatuses(data)}
                          buttonContent={
                            <div>
                              <Icon name="checkmark" color="green" />
                              <small>{`${data.bankCaseCount} referred`}</small>
                            </div>
                          }
                        />
                        :
                        <div>
                          <Icon name="checkmark" color="green" />
                          <small>{`${data.bankCaseCount} referred`}</small>
                        </div>
                    )
                  : <div>
                    <Icon name="delete" color="red" />
                    <small>{data.loanTrackerLeadDropID > 0 ? t('PIN required') : t('Not added')}</small>
                  </div>
                }
              </span>
            </Table.Cell>
          )
        }
        <Table.Cell>
          <span className="mobile-hide">
            {
              currentTab === 'aging_by_bankers' ? data.statusName : (
                <span>
                  {isPendingCancellation ?
                    t('Pending Cancellation', { ns: TRANSLATION_FILES.constants }) :
                    (data.bookingStatus ? t(data.bookingStatus.name, { ns: TRANSLATION_FILES.constants }) : '')}<br />
                  <small>{data.paymentStatus ? t(data.paymentStatus.name, { ns: TRANSLATION_FILES.constants }) : ''}</small>
                </span>
              )
            }
          </span>
          <span className="computer-hide">
            <small>
              {
                currentTab === 'aging_by_bankers' ?
                data.statusName : `${isPendingCancellation ? t('Pending Cancellation', { ns: TRANSLATION_FILES.constants }) : (data.bookingStatus ? t(data.bookingStatus.name, { ns: TRANSLATION_FILES.constants }) : '')} - ${data.paymentStatus ? data.paymentStatus.name : ''}`
              }
            </small>
            {
              this.hasInternalDEAccess() && data.assignedMaPreferredName ? (
                <small style={{ float: 'right' }}>
                  <em>{`${t('Assigned')}: ${data.assignedMaPreferredName}`}</em>
                </small>
              ) : null
            }
          </span>
        </Table.Cell>
        {
          currentTab === 'aging_by_bankers' && (
            <Table.Cell collapsing>
              <small>
                {
                  // show logo if banker is direct to bank and bank logo exist
                  data.bankerDirectToBank && data.bankLogoSrc ? (
                    <Image src={data.bankLogoSrc} style={{ maxHeight: '20px', display: 'inline-block' }} />
                  ) : data.banker
                }
              </small>
              <small className="computer-hide" style={{ float: 'right', marginRight: '0.5em' }}>{data.bankShortName}</small>
            </Table.Cell>
          )
        }
        {
          currentTab === 'aging_by_bankers' && (
            <Table.Cell collapsing>
              <span className="mobile-hide">
                <small>{data.bankShortName}</small>
              </span>
            </Table.Cell>
          )
        }
        <Table.Cell collapsing>
          <span className="mobile-hide">
            {
              data.origin && data.origin.includes('marketplace') && this.hasMPDetailsAccess() ? (
                data.origin.includes('_') ?
                  <Popup
                    on="click"
                    trigger={
                      <a>
                        {data.maCreatedByPreferredName}
                      </a>
                  }
                    size="mini"
                    inverted
                    position="bottom right"
                    disabled
                    flowing
                  >
                    {
                    data.bookingCustomer ? (
                      <span style={{ fontSize: '15px' }}>
                        <div>{`${t('Name')}: ${data.bookingCustomer.name}`}</div>
                        {
                          data.bookingCustomer.email ?
                            <div>{`${t('Email')}: ${data.bookingCustomer.email}`}</div> :
                          null
                        }
                        <div>{`${t('Mobile')}: ${data.bookingCustomer.mobilePrefix}${data.bookingCustomer.mobile}`}</div>
                      </span>
                    ) : null
                  }
                  </Popup> :
                  <Popup
                    on="click"
                    trigger={
                      <a>
                        {data.maCreatedByPreferredName}
                      </a>
                  }
                    onOpen={() => {
                      this.fetchMarketplaceUserDetails(data.maUserID);
                    }}
                    size="mini"
                    inverted
                    position="bottom right"
                    disabled
                    flowing
                  >
                    {
                    mpUserLoading ? (
                      <Loader active inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                    ) : (
                      <span style={{ fontSize: '15px' }}>
                        <div>{`${t('Name')}: ${mpUserDetails.fullName}`}</div>
                        <div>{`${t('Email')}: ${mpUserDetails.email}`}</div>
                        <div>{`${t('Mobile')}: ${mpUserDetails.mobilePrefix}${mpUserDetails.mobile}`}</div>
                        {
                          mpUserDetails.agencyName ? (
                            <div>{`${t('Agency Name')}: ${mpUserDetails.agencyName}`}</div>
                          ) : null
                        }
                        {
                          mpUserDetails.registrationNumber ? (
                            <div>{`${t('Registration Number')}: ${mpUserDetails.registrationNumber}`}</div>
                          ) : null
                        }
                      </span>
                    )
                  }
                  </Popup>
              ) : this.hasStaffAccess() ?
                <Link to={`/users/${currentTab === 'aging_by_bankers' ? data.createdByID : data.maUserAffiliateID}/`}>
                  {currentTab === 'aging_by_bankers' ? data.createdBy : data.maCreatedByPreferredName}
                </Link>
                : (currentTab === 'aging_by_bankers' ? data.createdBy : data.maCreatedByPreferredName)
            }

            {currentTab !== 'aging_by_bankers' ?
              <small>
                <br />{data.origin && data.origin.includes('marketplace_') ? t('Buyer') : data.maUserAffiliateCompanyBranchShortName}
              </small>
              : ''
            }
          </span>
          <span className="computer-hide">
            <small>
              <Timestamp
                timestamp={data.createdAt}
                format="DD/M/YYYY"
              />
              <br />
              <Timestamp
                timestamp={data.createdAt}
                format="hh:mm a"
              />
            </small>
            {
              (this.hasBookingNote(data) && currentTab === 'all') && (
                <Popup
                  trigger={
                    <div className="computer-hide" style={{ float: 'right', color: 'rgba(0,0,0,.5)' }}>
                      <Icon name="sticky note" color="grey" />
                    </div>
                  }
                  content={this.bookingNoteFormated(data)}
                  size="mini"
                  inverted
                />
              )
            }
            {
              currentTab !== 'all' ? (
                <Header
                  floated="right"
                  color={this.getAgingColor(data.currentAge)}
                  content={data.currentAge}
                />
              ) : null
            }
          </span>
        </Table.Cell>
        {
          this.hasInternalDEAccess() ? (
            <Table.Cell collapsing textAlign="left">
              <span className="mobile-hide">
                {
                  data.assignedMaPreferredName ?
                  data.assignedMaPreferredName : '-'
                }
              </span>
            </Table.Cell>
          ) : null
        }
        <Table.Cell collapsing>
          <span className="mobile-hide">
            {
              this.isShowTerminationLetter(data) ? (
                <Popup
                  trigger={
                    <Link
                      as="a"
                      className="ui compact icon primary button"
                      to={`${config.get('bookApiURL')}/bookings/${data.id}/print/termination/`}
                      target="_blank"
                      onClick={this.handlePrint}
                    >
                      <Icon name="print" />
                    </Link>
              } content={t('Print Termination Letter')}
                />
            ) : null
            }
            {
              this.isShowLoanReminderLetter(data) ? (
                <Popup
                  trigger={
                    <Link
                      as="a"
                      className="ui compact icon primary button"
                      to={`${config.get('bookApiURL')}/bookings/${data.id}/print/loan_reminder/`}
                      target="_blank"
                      onClick={this.handlePrint}
                    >
                      <Icon name="print" />
                    </Link>
              } content={t('Print Loan Reminder Letter')}
                />
            ) : null
            }
            {
              this.isShowSpaReminderLetter(data) ? (
                <Popup
                  trigger={
                    <Link
                      as="a"
                      className="ui compact icon primary button"
                      to={`${config.get('bookApiURL')}/bookings/${data.id}/print/spa_reminder/`}
                      target="_blank"
                      onClick={this.handlePrint}
                    >
                      <Icon name="print" />
                    </Link>
              } content={t('Print SPA Reminder Letter')}
                />
            ) : null
            }
          </span>
        </Table.Cell>
        <Table.Cell collapsing>
          <span className="mobile-hide">
            <Link to={`/bookings/${data.id}/`}>
              <Icon name="chevron right" />
            </Link>
          </span>
        </Table.Cell>
      </Table.Row>
    );
  }
  render() {
    if (this.props.hideBookingList && this.state.data.length < 1) {
      return <Grid />;
    }
    const { currentTab, loading, data, tabss } = this.state;
    const { t } = this.props;
    const sortItems = currentTab === 'aging_by_lawyers' ? [
      {
        text: 'Date Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'created_at',
        sortDirection: 'asc',
      },
      {
        text: 'Date Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'created_at',
        sortDirection: 'desc',
      },
      {
        text: 'Unit Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'property.unit_no.keyword',
        sortDirection: 'asc',
      },
      {
        text: 'Unit Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'property.unit_no.keyword',
        sortDirection: 'desc',
      },
      {
        text: 'Status Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'status.keyword',
        sortDirection: 'asc',
      },
      {
        text: 'Status Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'status.keyword',
        sortDirection: 'desc',
      },
      {
        text: 'Type Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'type.keyword',
        sortDirection: 'asc',
      },
      {
        text: 'Type Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'type.keyword',
        sortDirection: 'desc',
      },
      {
        text: 'Days Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'aging_days',
        sortDirection: 'asc',
      },
      {
        text: 'Days Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'aging_days',
        sortDirection: 'desc',
      },
      {
        text: 'Purchaser Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'purchaser.name.keyword',
        sortDirection: 'asc',
      },
      {
        text: 'Purchaser Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'purchaser.name.keyword',
        sortDirection: 'desc',
      },
    ] : [
      {
        text: 'Created Date Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'bank_case.created_at' : 'booking.created_at',
        sortDirection: 'asc',
      },
      {
        text: 'Created Date Descending',
        icon: 'sort alphabet descending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'bank_case.created_at' : 'booking.created_at',
        sortDirection: 'desc',
      },
      {
        text: 'Unit Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'bank_case.reference_no' : 'project_unit.reference',
        sortDirection: 'asc',
      },
      {
        text: 'Unit Descending',
        icon: 'sort alphabet descending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'bank_case.reference_no' : 'project_unit.reference',
        sortDirection: 'desc',
      },
      {
        text: 'Status Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'bank_case.status' : 'booking_status.name',
        sortDirection: 'asc',
      },
      {
        text: 'Status Descending',
        icon: 'sort alphabet descending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'bank_case.status' : 'booking_status.name',
        sortDirection: 'desc',
      },
      {
        text: 'Reserved By Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'affiliate.name' : 'booking.ma_created_by_preferred_name',
        sortDirection: 'asc',
      },
      {
        text: 'Reserved By Descending',
        icon: 'sort alphabet descending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'affiliate.name' : 'booking.ma_created_by_preferred_name',
        sortDirection: 'desc',
      },
      {
        text: 'Assigned Staff Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'booking.assigned_ma_preferred_name',
        sortDirection: 'asc',
      },
      {
        text: 'Assigned Staff Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'booking.assigned_ma_preferred_name',
        sortDirection: 'desc',
      },
      {
        text: 'Days Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: this.handleGetDaysSortColumn(),
        sortDirection: 'asc',
      },
      {
        text: 'Days Descending',
        icon: 'sort alphabet descending',
        sortColumn: this.handleGetDaysSortColumn(),
        sortDirection: 'desc',
      },
      {
        text: 'Banker Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'bankers.name',
        sortDirection: 'asc',
      },
      {
        text: 'Banker Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'bankers.name',
        sortDirection: 'desc',
      },
      {
        text: 'Bank Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'banks.short_name',
        sortDirection: 'asc',
      },
      {
        text: 'Bank Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'banks.short_name',
        sortDirection: 'desc',
      },
      {
        text: 'Code Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'bank_case.lead_id',
        sortDirection: 'asc',
      },
      {
        text: 'Code Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'bank_case.lead_id',
        sortDirection: 'desc',
      },
    ];
    sortItems.push(...this.statusDateSortItems());
    const isMalaysia = this.props.auth.company && this.props.auth.company.countryCode === 'my';
    // CPI-1209: the plain Excel / CSV items. isCountryVietnam, not `!== 'my'`, which would add ID.
    const showPlainExports = isMalaysia ||
      isCountryVietnam(this.props.auth.company && this.props.auth.company.countryCode);
    const exportItems = currentTab === 'aging_by_lawyers' ? [
      {
        text: 'Excel',
        icon: 'download',
        onClick: async () => {
          const { store } = this.context;
          try {
            const response = await serverRequestGet(
              `/bookings/export/aging/lawyers/?${this.state.stringifyQuery}`,
              store,
            );
            if (response.error) {
              await store.dispatch(flashErrorMessage({ message: response.message }));
              return;
            }
            store.dispatch(flashSuccessMessage({
              header: t('Request Success', { ns: TRANSLATION_FILES.translation }),
              message: `${t('We are processing your report, will send via email once the report is ready', { ns: TRANSLATION_FILES.translation })}.`,
            }));
          } catch (err) {
            await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
          }
        },
      },
    ] : this.exportItemsManager();
    if (currentTab !== 'aging_by_lawyers' && showPlainExports) {
      exportItems.push(
        {
          text: 'Excel',
          icon: 'download',
          href: this.exportURL('excel'),
        },
        {
          text: 'CSV',
          icon: 'download',
          href: this.exportURL('csv'),
        },
        {
          isDivider: true,
        },
      );
    }
    if (currentTab !== 'aging_by_lawyers' && showsPaymentExcelExport(this.props.auth)) {
      exportItems.push({
        text: 'Payment\nExcel',
        icon: 'download',
        href: `${config.get('bookApiURL')}/bookings/export/payments/?`,
        dataTarget: 'paymentexcel',
      });
    }
    if (currentTab !== 'all' && currentTab !== 'aging_by_lawyers') {
      exportItems.push({
        text: 'Excel\n(detailed)',
        icon: 'download',
        href: this.exportURL('excel', false, true),
      });
    }
    return (
      <Grid verticalAlign="middle" className="booking-list">
        <Grid.Row className="tab-menu">
          <Grid.Column width={16}>
            <Menu
              attached="top"
              tabular
            >
              {
                tabss.map((tab, key) => (
                  <Menu.Item
                    key={key}
                    name={tab.name}
                    onClick={this.handleChangeTab}
                    active={currentTab === tab.name}
                  >{t(tab.text, { ns: namespaces[tab.name === 'all' ? 1 : 0] }).toUpperCase()}</Menu.Item>
                ))
              }
            </Menu>
          </Grid.Column>
        </Grid.Row>
        {this.renderMenuTool()}

        {/* List Data */}
        <Grid.Row className="app--listdata">
          <Grid.Column>
            <Dimmer
              inverted style={{ zIndex: 20 }}
              active={loading && data.length > 0}
            >
              <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
            </Dimmer>
            <Grid className="booking-data">
              <Grid.Row className="header">
                <Grid.Column mobile={10} tablet={6} computer={6}>
                  <Header as="h2">{this.getTabHeader()}</Header>
                </Grid.Column>
                <Grid.Column mobile={6} tablet={10} computer={10} textAlign="right" className="download">
                  <SortButton
                    floated="right"
                    loading={loading}
                    items={sortItems}
                    onSort={this.handleSortData}
                  />
                  {
                    exportItems.length > 0 && (
                      <SortButton
                        floated="right"
                        icon="download"
                        loading={loading}
                        items={exportItems}
                      />
                    )
                  }
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={16}>
                  <Table basic="very" sortable className="bookings">
                    {this.renderTableHeaders(sortItems)}
                    <Table.Body>
                      {
                        data.length > 0 ?
                          data.map(this.renderTableRow) : (
                            <Table.Row>
                              <Table.Cell colSpan={10} textAlign="center">
                                {
                                  loading ?
                                    <Loader active inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                                  : <p>{t('No bookings found')}.</p>
                                }
                              </Table.Cell>
                            </Table.Row>
                          )
                      }
                    </Table.Body>
                  </Table>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column textAlign="center">
            <PageNav
              upward
              currentPage={this.state.currentPage}
              count={this.state.count}
              limit={this.state.limit}
              offset={this.state.offset}
              dataSize={data.length}
              loading={loading}
              onChange={this.handleChangePage}
              noScrollTop={this.props.noScrollTop}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default withTranslation(namespaces)(withRouter(connect(BookingsList.mapStateToProps)(BookingsList)));



// WEBPACK FOOTER //
// ./src/components/BookingsList.jsx